import {FC} from 'react'
import {Navigate} from 'react-router-dom'
import {useAuth} from '../modules/auth'
import {canAccessAdminOrManagerFeatures} from '../modules/auth/core/roleAccess'
import {WithChildren} from '../../_metronic/helpers'

const AdminOrManagerAccessGuard: FC<WithChildren> = ({children}) => {
  const {currentUser} = useAuth()

  if (!canAccessAdminOrManagerFeatures(currentUser)) {
    return <Navigate to='/404' replace />
  }

  return <>{children}</>
}

export {AdminOrManagerAccessGuard}
